import { makeStyles } from "tss-react/mui";

export const useTooltipIconButtonStyles = makeStyles()(() => ({
    wrapper: {
        display: "inline-block",
    },
}));
